var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMambooLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M76.491 66.418H85.6683",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M76.4903 66.4171C75.4791 66.4171 74.4778 66.2179 73.5436 65.831C72.6093 65.444 71.7604 64.8768 71.0454 64.1618C70.3303 63.4467 69.7632 62.5978 69.3762 61.6636C68.9892 60.7293 68.79 59.728 68.79 58.7168",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M68.79 58.7156V42.2441",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "M53.3899 42.2453C53.3899 40.203 54.2012 38.2444 55.6453 36.8003C57.0894 35.3562 59.048 34.5449 61.0903 34.5449C63.1325 34.5449 65.0911 35.3562 66.5352 36.8003C67.9793 38.2444 68.7906 40.203 68.7906 42.2453",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M53.3899 76.0039V42.2441",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M53.3902 76.0059C53.3902 78.0481 52.5789 80.0067 51.1348 81.4508C49.6907 82.8949 47.7321 83.7062 45.6899 83.7062C43.6476 83.7062 41.689 82.8949 40.2449 81.4508C38.8008 80.0067 37.9895 78.0481 37.9895 76.0059",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M37.9895 76.0044V30.877",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "M22.5891 30.8781C22.5891 28.8358 23.4004 26.8772 24.8445 25.4331C26.2886 23.989 28.2472 23.1777 30.2894 23.1777C32.3317 23.1777 34.2903 23.989 35.7344 25.4331C37.1785 26.8772 37.9898 28.8358 37.9898 30.8781",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M22.5891 51.0157V30.877",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "M22.5887 51.0156C22.5887 53.0579 21.7774 55.0165 20.3334 56.4606C18.8893 57.9047 16.9307 58.716 14.8884 58.716",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M5.71118 58.7168H14.8892",
    stroke: "white",
    strokeWidth: 10.4706,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3385 0.232422C32.2235 0.232422 34.0313 0.981189 35.3643 2.31402C36.6972 3.64684 37.4461 5.45456 37.4463 7.33954C37.4464 8.74535 37.0296 10.1196 36.2487 11.2886C35.4678 12.4575 34.3578 13.3686 33.059 13.9067C31.7602 14.4448 30.3311 14.5856 28.9522 14.3114C27.5734 14.0373 26.3069 13.3604 25.3128 12.3663C24.3187 11.3723 23.6416 10.1059 23.3673 8.72706C23.093 7.34828 23.2338 5.91911 23.7717 4.6203C24.3097 3.32149 25.2207 2.21137 26.3896 1.43034C27.5585 0.649298 28.9327 0.232422 30.3385 0.232422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0899 11.6074C62.975 11.6074 64.7829 12.3563 66.1158 13.6892C67.4488 15.0222 68.1976 16.8301 68.1976 18.7152C68.1976 20.121 67.7808 21.4952 66.9998 22.664C66.2188 23.8329 65.1087 24.7439 63.8099 25.2819C62.5112 25.8199 61.082 25.9606 59.7033 25.6864C58.3245 25.4121 57.0581 24.7352 56.064 23.7411C55.07 22.7471 54.393 21.4806 54.1188 20.1018C53.8445 18.7231 53.9853 17.2939 54.5232 15.9952C55.0612 14.6964 55.9722 13.5863 57.1411 12.8053C58.31 12.0243 59.6841 11.6074 61.0899 11.6074Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMambooLogo);
export default __webpack_public_path__ + "static/media/mamboo-logo.c8094eed4435c5db87764cf3c6c6d7c6.svg";
export { ForwardRef as ReactComponent };